import * as logger from '@mamdev/navigator.frontend-logger'
import { AditionClientConfig, PermissionClientOptions } from '@mamdev/navigator.permissions'
import { getBrand } from './brand'
import { getStage } from './stage'
import { xUiApp } from './xuiapp'
import { loadScript } from './load-script'
import { getUrlParam } from './url-param'

export const PPP_LOAD_TIMEOUT = 5000

function getPppStage(): AditionClientConfig['stage'] {
  const stage = getStage()
  let pppStage: AditionClientConfig['stage'] = 'live'
  if (stage === 'dev' || stage === 'qa') {
    pppStage = 'qa'
  }
  return pppStage
}

export function loadPppClient(): Promise<void> {
  const pppClientUrl = `https://dl.${getBrand()}/permission/${getPppStage()}/navapps/v1/ppp/js/permission-client.js`
  logger.debug('loading PPP from', pppClientUrl)

  return loadScript(pppClientUrl, PPP_LOAD_TIMEOUT)
}

export async function initPpp(accessToken: string): Promise<boolean> {
  let portal: PermissionClientOptions['portal']
  switch(getBrand()) {
    case 'gmx.at':
      portal = 'gmxat'
      break
    case 'gmx.net':
      portal = 'gmx'
      break
    default:
      portal = 'webde'
  }

  const section = getUrlParam('section')

  const pppConfig: PermissionClientOptions = {
    portal,
    category: section.indexOf('navigator') !== -1 ? 'mail' : 'homepage',
    section: section ||  'landingpage',
    stage: getPppStage(),
    forcePermissionLayer: 'tcf_v2',
    accessToken,
    xUIApp: xUiApp,
    touchpointName: 'navigator',
    touchpointReference: `${location.origin}${location.pathname}`,
    consentParameters: {}
  }

  logger.debug('initializing PPP with config:', JSON.stringify(pppConfig, null, 2))

  return new Promise((resolve, reject) => {
    try {
      window.PermissionClient.init({
        ...pppConfig,
        onComplete: function(success, errorMessage) {
          logger.debug('PPP onComplete', success, errorMessage)
          if (success) {
            resolve(true)
          } else {
            reject(errorMessage)
          }
        }
      })
    } catch (e) {
      reject(e.message)
    }
  })
}

export async function requestPppLayer(accessToken: string): Promise<boolean> {
  try {
    return await initPpp(accessToken)
  } catch (e) {
    logger.error(`Error while initializing PPP`, e)
  }
  return false
}
